import ToggleGroup from 'ui/ToggleGroup';
import DOMHelper from 'utils/DOMHelpers';

/**
 * * Class Accordeon that handles base functionality for ToggleGroups like Tabs and Accordions.
 * @class
 */
class Accordeon {

    /**
     * Make a new Accordeon.
     * @constructs
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;
        this._options.scrollto = options.scrollto !== undefined ? options.scrollto : true;

        this._initialize();
    }

    /**
     * Initialize
     * @private
     */
    _initialize() {
        let initialTriggerSelector = this._options.triggerSelector;
        let triggerElements = Array.prototype.slice.call(document.querySelectorAll(this._options.triggerSelector));
        for (let i = 0, length = triggerElements.length; i < length; i++) {
            triggerElements[i].appendChild(this._appendtoggleLabels(this._options.labelopen, this._options.labelclose));
            this.returnNode = DOMHelper.wrapChildNodes(triggerElements[i], 'a');
            this.returnNode.setAttribute('href', '#');
            this._options.triggerSelector = `${initialTriggerSelector} a`;
        }

        this._toggleGroup = new ToggleGroup(this._element, this._options);

    }

    /**
     *  _appendtoggleLabels
     *  @param {string} labelopen - Open label text
     *  @param {string} labelclose - Close label text
     *  @private
     *  @return {HTMLElement} - a node
     */
    _appendtoggleLabels(labelopen, labelclose) {
        const tmpl = `<label class="accordion_label--open">${labelopen}</label><label class="accordion_label--close">${labelclose}</label>`;
        const _div = document.createElement('div');
        _div.className = 'accordion_labels';
        _div.innerHTML = tmpl;

        return _div;
    }

}

export default Accordeon;
